if (typeof FeaturedAmbassadors === 'undefined') {
    class FeaturedAmbassadors extends HTMLElement {
        connectedCallback() {
            const swiperEl = this.querySelector('.swiper');
            if (!swiperEl || this.swiper) return;

            whenReady('Swiper', () => {
                try {
                    this.swiper = new Swiper(swiperEl, {
                        loop: true,
                        a11y: true,
                        spaceBetween: 8,
                        slidesPerView: "auto",
                        navigation: {
                            nextEl: this.closest(".shopify-section").querySelector('.swiper-next'),
                        },
                        mousewheel: { forceToAxis: true, thresholdDelta: 12 },
                        breakpoints: {
                            768: { 
                                slidesPerView: 3,
                                spaceBetween: 16,
                            },
                        },
                        modules: [Swiper.A11y, Swiper.Mousewheel, Swiper.Navigation]
                    });
                } catch (error) {
                    console.error('FeaturedAmbassadors: Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    if (!window.customElements.get('featured-ambassadors')) {
        window.customElements.define('featured-ambassadors', FeaturedAmbassadors);
    }
}
